import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { NavigationManagerContext } from './hook.manager.js';

const Link = forwardRef(
  function Link2(props, ref) {
    const { enhanceLink } = useContext(NavigationManagerContext);
    return (enhanceLink == null ? void 0 : enhanceLink(props, ref)) ?? /* @__PURE__ */ jsx("a", { ...props, ref, children: props.children });
  }
);

export { Link };
//# sourceMappingURL=comp.link.js.map
